export const HEADER_HEIGHT_PX = 60;
export const IMPERSONATION_BANNER_HEIGHT_PX = 50;

const px = (value) => `${value}px`;

export const DEFAULT_FIXED_TOP_OFFSET = px(HEADER_HEIGHT_PX);
export const DEFAULT_IMPERSONATION_BANNER_HEIGHT = px(IMPERSONATION_BANNER_HEIGHT_PX);
export const IMPERSONATION_FIXED_TOP_OFFSET = px(HEADER_HEIGHT_PX + IMPERSONATION_BANNER_HEIGHT_PX);

// The three fixed chrome layers stack top-to-bottom — impersonation banner,
// then status banner, then header — so each variable is a slot offset (the top
// edge of the next layer) rather than a per-feature height. That keeps a
// component from being positioned by a variable named after another feature:
// the status banner reads --app-status-banner-top, the header reads
// --app-header-top-offset. The child reports height 0 whenever no notice is
// displayed (including when it leaves the tree), so the measured status height
// alone is authoritative — no separate visibility flag is needed.
export const buildAppShellStyle = ({
  showImpersonationBanner,
  impersonationBannerHeight,
  statusBannerHeight,
}) => {
  const impersonation = showImpersonationBanner
    ? impersonationBannerHeight || IMPERSONATION_BANNER_HEIGHT_PX
    : 0;
  const status = statusBannerHeight || 0;

  return {
    '--app-status-banner-top': px(impersonation),
    '--app-header-top-offset': px(impersonation + status),
    '--app-fixed-top-offset': px(HEADER_HEIGHT_PX + impersonation + status),
  };
};

export const buildAppContentStyle = ({
  user,
  pathname,
  onMobile,
  isImpersonationSetupRoute,
}) => ({
  marginLeft: user !== null
    && !pathname.includes('app/chrome/')
    && !onMobile
    && !isImpersonationSetupRoute
    ? '80px'
    : undefined,
  marginTop: isImpersonationSetupRoute ? '0px' : 'var(--app-fixed-top-offset)',
});
